<template>
  <div class="side-nav">
    <div class="side-nav-inner">
      <ul class="side-nav-menu scrollable">
        <template v-if="isAdmin">
          <router-link
            class="nav-item"
            :to="{ name: 'UsersAdmin' }"
            tag="li"
            exact
          >
            <a href="#">
              <span class="icon-holder">
                <i class="anticon anticon-user"></i>
              </span>
              <span class="title">Пользователи</span>
            </a>
          </router-link>
          <router-link
            class="nav-item"
            :to="{ name: 'PlaceSchool' }"
            tag="li"
            exact
          >
            <a href="#">
              <span class="icon-holder">
                <i class="anticon anticon-home"></i>
              </span>
              <span class="title">Адресс / Школа</span>
            </a>
          </router-link>
          <router-link
            class="nav-item"
            :to="{ name: 'FacultySpec' }"
            tag="li"
            exact
          >
            <a href="#">
              <span class="icon-holder">
                <i class="anticon anticon-interation"></i>
              </span>
              <span class="title">Факультет / Спец.</span>
            </a>
          </router-link>

          <router-link class="nav-item" :to="{ name: 'Plan' }" tag="li" exact>
            <a href="#">
              <span class="icon-holder">
                <i class="anticon anticon-schedule"></i>
              </span>
              <span class="title">План</span>
            </a>
          </router-link>
          <li class="devider_side_li"></li>
        </template>
        
        <router-link
          class="nav-item"
          :to="{ name: 'ApplicantsList' }"
          tag="li"
          exact
        >
          <a href="#">
            <span class="icon-holder">
              <i class="anticon anticon-user-add"></i>
            </span>
            <span class="title">Список абитуриентов</span>
          </a>
        </router-link>

        <router-link
          class="nav-item"
          :to="{ name: 'DocumentsList' }"
          tag="li"
          exact
        >
          <a href="#">
            <span class="icon-holder">
              <i class="anticon anticon-audit"></i>
            </span>
            <span class="title">Список документов</span>
          </a>
        </router-link>

        <!-- <li class="nav-item">
          <router-link :to="{ name: 'Temp' }" exact>
            <span class="icon-holder">
              <i class="anticon anticon-solution"></i>
            </span>
            <span class="title">Эксперимент</span>
          </router-link>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  name: "MainSide",
  data: ()=>({
    roles: []
  }),
  computed: {
    isAdmin(){
      return this.roles.filter(i=>{return i.name=="Администратор"}).length>0
    }
  },
  created(){
    this.roles = this.$store.state['user'].user.user.roles
  },
  mounted(){
    
  }
};
</script>
<style lang="scss" scoped></style>
